import { useMemo } from 'react';
import { useUrlSyncedSearch } from '@/hooks/useUrlSyncedSearch';
import { filterRowsBySearch, type SearchableValue } from '@/utils/listSearch';

interface UseLocalListSearchOptions<TRow> {
  rows: TRow[] | undefined;
  appliedText: string | undefined;
  onApply: (text: string | undefined) => void;
  toSearchableValues: (row: TRow) => SearchableValue[];
}

export function useLocalListSearch<TRow>({
  rows,
  appliedText,
  onApply,
  toSearchableValues,
}: UseLocalListSearchOptions<TRow>) {
  const { searchText, setSearchText } = useUrlSyncedSearch({ appliedText, onApply });

  const visibleRows = useMemo(
    () => filterRowsBySearch(rows, appliedText, toSearchableValues),
    [rows, appliedText, toSearchableValues],
  );

  return { searchText, setSearchText, visibleRows };
}
